<div class="grid">
  <div class="grid__col-12">
    <div class="no-results">
      <!-- Error image -->
      <img
        *ngIf="emptyImageURL"
        [src]="emptyImageURL"
        [alt]="i18n.Core_Empty_Image_Alt"
      />

      <div class="guts-m-t-2">
        <!-- Error message -->
        <h3 class="h3 guts-p-b-quart break">
          {{ noResultsFoundMessage }}
        </h3>

        <!-- Error advice -->
        <p class="no-results__advice font-medium guts-p-b-2 color-ebony-a61">
          {{ noResultsFoundAdvice }}
        </p>

        <!-- Support message -->
        <div
          *ngIf="supportMessage$ | async as message"
          class="no-results__support font-medium guts-p-b-2 color-ebony-a61"
        >
          <p [innerHTML]="message"></p>
        </div>

        <div *ngIf="filtersApplied && !hasError">
          <!-- Language Settings -->
          <a
            *ngIf="filtersApplied"
            df-button
            dfButtonType="passive"
            [href]="languageSettingsUrl"
            class="guts-m-r-1"
            data-dgat="search-no-results-4ff"
          >
            {{ i18n.Core_LanguageSettings }}
          </a>

          <!-- Clear filters -->
          <button
            *ngIf="filtersApplied"
            df-button
            dfButtonType="primary"
            (click)="clearFilters()"
            data-dgat="search-no-results-a87"
          >
            {{ resetFiltersText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
